const moment = require('moment')

export function hexToRgb (hex: string) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null
}
export function dateFunction () {
  const dateString = moment().format('DD MMMM YYYY - HH:mm')
  return dateString
}

export async function executeInParallel (tasks: Promise<any>[]) {
  const result = tasks.map(async (task) => await task)
  return result
}
